import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type UseRankingListQueryParams = Exclude<Parameters<typeof SSF.api.resultsRankingList>[0], undefined>;

const keys = createQueryKeySet<UseRankingListQueryParams>('ranking');

export function useRankingListQuery(params: UseRankingListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.resultsRankingList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
